var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoboticArm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.647 17.647",
    style: {
      enableBackground: "new 0 0 17.647 17.647"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#030104"
    },
    cx: 2.648,
    cy: 7.546,
    r: 1.11
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030104"
    },
    d: "M5.296,7.546c0-1.46-1.188-2.648-2.648-2.648C1.189,4.898,0,6.086,0,7.546s1.188,2.648,2.648,2.648 C4.108,10.194,5.296,9.006,5.296,7.546z M2.648,9.567c-1.114,0-2.021-0.906-2.021-2.021s0.907-2.021,2.021-2.021 c1.115,0,2.021,0.906,2.021,2.021S3.762,9.567,2.648,9.567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030104"
    },
    d: "M5.655,9.221C5.527,9.576,5.324,9.91,5.041,10.194c-0.306,0.305-0.668,0.516-1.052,0.641 l2.896,2.898h-0.56v2.035h5.435v-2.035h-1.596L5.655,9.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030104"
    },
    d: "M17.572,4.686c-0.104-0.104-0.271-0.107-0.376-0.004l-2.418,2.364l-1.78-0.934l-0.467-2.034 l1.192-1.618l3.206,1.073c0.049,0.016,0.099,0.018,0.146,0.007c0.087-0.02,0.162-0.083,0.191-0.175 c0.049-0.139-0.027-0.291-0.166-0.337l-3.391-1.135c-0.11-0.038-0.23,0.001-0.298,0.094l-1.085,1.47l-0.895,0.205l0.126,0.548 L5.294,5.648c0.232,0.297,0.407,0.646,0.497,1.038c0.096,0.42,0.085,0.839-0.014,1.232l6.298-1.447l0.126,0.548L13.154,6.8 l-0.002-0.004L14.7,7.609c0.059,0.03,0.124,0.038,0.184,0.023c0.047-0.011,0.092-0.034,0.126-0.069l2.556-2.501 C17.672,4.96,17.674,4.791,17.572,4.686z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoboticArm);
export default __webpack_public_path__ + "static/media/roboticArm.517ad0d5786b0718dd741df598ab9ce5.svg";
export { ForwardRef as ReactComponent };